import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { getCurrentYear, getCurrentQuarter } from '../../../utils/utils';

export type Listkey = null | {
  list?: any;
  selectedYear?: number | string;
  joiningYear?: number | string;
  selectedQuarter?: number;
};

const initialState: Listkey = {
  list: null,
  selectedYear: getCurrentYear(),
  joiningYear: null,
  selectedQuarter: getCurrentQuarter(),
};

const appraisalCycleSlice = createSlice({
  name: 'appraisalData',
  initialState,
  reducers: {
    storeAppraisalCycleData: (state, action: PayloadAction<Listkey>) => {
      state.list = action.payload;
    },
    storeAppraisalCycleSelected: (state, action: PayloadAction<number | string>) => {
      state.selectedYear = action.payload || new Date().getFullYear();
    },
    storeEmployeeJoiningYear: (state, action: PayloadAction<number | string>) => {
      state.joiningYear = action.payload;
    },
    storeAppraisalCycleQuarter: (state, action: PayloadAction<number>) => {
      state.selectedQuarter = action.payload;
    },
  },
});

export const { storeAppraisalCycleData, storeAppraisalCycleSelected, storeEmployeeJoiningYear, storeAppraisalCycleQuarter } = appraisalCycleSlice.actions;

export default appraisalCycleSlice.reducer;
